export enum StorageKeys {
  USER_TOKEN = 'drheam:user+token',
  PROJECT_ID = 'drheam:id',
  DELEGATED_USER_TOKEN = 'drheam:delegated+user+token',
}
